import { Flex, FlexItem } from '@patternfly/react-core'
import { Th } from '@patternfly/react-table'
import * as React from 'react'
import { useMemo } from 'react'

import type { IEntry } from '@app/domain/instrument/instrument.interface'
import type { IDataInstrument } from '@app/domain/visit/visit.interface'
import { getLocalDate } from '@app/lib/time'
import { SmallButton } from '@app/utils/styles/small-button'

interface Props {
  entry: IEntry
  instrument: IDataInstrument
  editResponses?: boolean
  openEditInstrumentModal?: () => void
}

export const ResponseHistoryHeaderColumn = ({
  entry,
  editResponses,
  instrument,
  openEditInstrumentModal,
}: Props) => {
  const getDate = useMemo(() => {
    if (!entry.visitTime && !entry.completionDateTime) {
      return null
    }
    return getLocalDate(new Date(entry.visitTime ?? entry.completionDateTime))
  }, [entry])

  const canEditResponses =
    editResponses &&
    entry &&
    instrument?.questions &&
    Object.keys(instrument.questions).length > 0

  return (
    <Th modifier="wrap" width={10}>
      <Flex direction={{ default: 'row' }}>
        <FlexItem>{getDate} </FlexItem>
        <FlexItem>
          {canEditResponses ? (
            <FlexItem>
              <SmallButton
                variant="secondary"
                onClick={openEditInstrumentModal}
              >
                Edit Responses
              </SmallButton>
            </FlexItem>
          ) : null}
        </FlexItem>
      </Flex>
    </Th>
  )
}
